const countryList = [
    { text: 'Afghanistan', value: 'Afghanistan', flag: 'af' },
    { text: 'Aland Islands', value: 'Aland Islands', flag: 'ax' },
    { text: 'Albania', value: 'Albania', flag: 'al' },
    { text: 'Algeria', value: 'Algeria', flag: 'dz' },
    { text: 'American Samoa', value: 'American Samoa', flag: 'as' },
    { text: 'Andorra', value: 'Andorra', flag: 'ad' },
    { text: 'Angola', value: 'Angola', flag: 'ao' },
    { text: 'Anguilla', value: 'Anguilla', flag: 'ai' },
    { text: 'Antigua', value: 'Antigua', flag: 'ag' },
    { text: 'Argentina', value: 'Argentina', flag: 'ar' },
    { text: 'Armenia', value: 'Armenia', flag: 'am' },
    { text: 'Aruba', value: 'Aruba', flag: 'aw' },
    { text: 'Australia', value: 'Australia', flag: 'au' },
    { text: 'Austria', value: 'Austria', flag: 'at' },
    { text: 'Azerbaijan', value: 'Azerbaijan', flag: 'az' },
    { text: 'Bahamas', value: 'Bahamas', flag: 'bs' },
    { text: 'Bahrain', value: 'Bahrain', flag: 'bh' },
    { text: 'Bangladesh', value: 'Bangladesh', flag: 'bd' },
    { text: 'Barbados', value: 'Barbados', flag: 'bb' },
    { text: 'Belarus', value: 'Belarus', flag: 'by' },
    { text: 'Belgium', value: 'Belgium', flag: 'be' },
    { text: 'Belize', value: 'Belize', flag: 'bz' },
    { text: 'Benin', value: 'Benin', flag: 'bj' },
    { text: 'Bermuda', value: 'Bermuda', flag: 'bm' },
    { text: 'Bhutan', value: 'Bhutan', flag: 'bt' },
    { text: 'Bolivia', value: 'Bolivia', flag: 'bo' },
    { text: 'Bosnia', value: 'Bosnia', flag: 'ba' },
    { text: 'Botswana', value: 'Botswana', flag: 'bw' },
    { text: 'Bouvet Island', value: 'Bouvet Island', flag: 'bv' },
    { text: 'Brazil', value: 'Brazil', flag: 'br' },
    { text: 'British Virgin Islands', value: 'British Virgin Islands', flag: 'vg' },
    { text: 'Brunei', value: 'Brunei', flag: 'bn' },
    { text: 'Bulgaria', value: 'Bulgaria', flag: 'bg' },
    { text: 'Burkina Faso', value: 'Burkina Faso', flag: 'bf' },
    { text: 'Burma', value: 'Burma', flag: 'mm' },
    { text: 'Burundi', value: 'Burundi', flag: 'bi' },
    { text: 'Caicos Islands', value: 'Caicos Islands', flag: 'tc' },
    { text: 'Cambodia', value: 'Cambodia', flag: 'kh' },
    { text: 'Cameroon', value: 'Cameroon', flag: 'cm' },
    { text: 'Canada', value: 'Canada', flag: 'ca' },
    { text: 'Cape Verde', value: 'Cape Verde', flag: 'cv' },
    { text: 'Cayman Islands', value: 'Cayman Islands', flag: 'ky' },
    { text: 'Central African Republic', value: 'Central African Republic', flag: 'cf' },
    { text: 'Chad', value: 'Chad', flag: 'td' },
    { text: 'Chile', value: 'Chile', flag: 'cl' },
    { text: 'China', value: 'China', flag: 'cn' },
    { text: 'Christmas Island', value: 'Christmas Island', flag: 'cx' },
    { text: 'Cocos Islands', value: 'Cocos Islands', flag: 'cc' },
    { text: 'Colombia', value: 'Colombia', flag: 'co' },
    { text: 'Comoros', value: 'Comoros', flag: 'km' },
    { text: 'Congo', value: 'Congo', flag: 'cd' },
    { text: 'Congo Brazzaville', value: 'Congo Brazzaville', flag: 'cg' },
    { text: 'Cook Islands', value: 'Cook Islands', flag: 'ck' },
    { text: 'Costa Rica', value: 'Costa Rica', flag: 'cr' },
    { text: 'Cote Divoire', value: 'Cote Divoire', flag: 'ci' },
    { text: 'Croatia', value: 'Croatia', flag: 'hr' },
    { text: 'Cuba', value: 'Cuba', flag: 'cu' },
    { text: 'Cyprus', value: 'Cyprus', flag: 'cy' },
    { text: 'Czech Republic', value: 'Czech Republic', flag: 'cz' },
    { text: 'Denmark', value: 'Denmark', flag: 'dk' },
    { text: 'Djibouti', value: 'Djibouti', flag: 'dj' },
    { text: 'Dominica', value: 'Dominica', flag: 'dm' },
    { text: 'Dominican Republic', value: 'Dominican Republic', flag: 'do' },
    { text: 'Ecuador', value: 'Ecuador', flag: 'ec' },
    { text: 'Egypt', value: 'Egypt', flag: 'eg' },
    { text: 'El Salvador', value: 'El Salvador', flag: 'sv' },
    { text: 'England', value: 'England', flag: 'gb' },
    { text: 'Equatorial Guinea', value: 'Equatorial Guinea', flag: 'gq' },
    { text: 'Eritrea', value: 'Eritrea', flag: 'er' },
    { text: 'Estonia', value: 'Estonia', flag: 'ee' },
    { text: 'Ethiopia', value: 'Ethiopia', flag: 'et' },
    { text: 'Europeanunion', value: 'Europeanunion', flag: 'eu' },
    { text: 'Falkland Islands', value: 'Falkland Islands', flag: 'fk' },
    { text: 'Faroe Islands', value: 'Faroe Islands', flag: 'fo' },
    { text: 'Fiji', value: 'Fiji', flag: 'fj' },
    { text: 'Finland', value: 'Finland', flag: 'fi' },
    { text: 'France', value: 'France', flag: 'fr' },
    { text: 'French Guiana', value: 'French Guiana', flag: 'gf' },
    { text: 'French Polynesia', value: 'French Polynesia', flag: 'pf' },
    { text: 'French Territories', value: 'French Territories', flag: 'tf' },
    { text: 'Gabon', value: 'Gabon', flag: 'ga' },
    { text: 'Gambia', value: 'Gambia', flag: 'gm' },
    { text: 'Georgia', value: 'Georgia', flag: 'ge' },
    { text: 'Germany', value: 'Germany', flag: 'de' },
    { text: 'Ghana', value: 'Ghana', flag: 'gh' },
    { text: 'Gibraltar', value: 'Gibraltar', flag: 'gi' },
    { text: 'Greece', value: 'Greece', flag: 'gr' },
    { text: 'Greenland', value: 'Greenland', flag: 'gl' },
    { text: 'Grenada', value: 'Grenada', flag: 'gd' },
    { text: 'Guadeloupe', value: 'Guadeloupe', flag: 'gp' },
    { text: 'Guam', value: 'Guam', flag: 'gu' },
    { text: 'Guatemala', value: 'Guatemala', flag: 'gt' },
    { text: 'Guinea', value: 'Guinea', flag: 'gn' },
    { text: 'Guinea-Bissau', value: 'Guinea-Bissau', flag: 'gw' },
    { text: 'Guyana', value: 'Guyana', flag: 'gy' },
    { text: 'Haiti', value: 'Haiti', flag: 'ht' },
    { text: 'Heard Island', value: 'Heard Island', flag: 'hm' },
    { text: 'Honduras', value: 'Honduras', flag: 'hn' },
    { text: 'Hong Kong', value: 'Hong Kong', flag: 'hk' },
    { text: 'Hungary', value: 'Hungary', flag: 'hu' },
    { text: 'Iceland', value: 'Iceland', flag: 'is' },
    { text: 'India', value: 'India', flag: 'in' },
    { text: 'Indian Ocean Territory', value: 'Indian Ocean Territory', flag: 'io' },
    { text: 'Indonesia', value: 'Indonesia', flag: 'id' },
    { text: 'Iran', value: 'Iran', flag: 'ir' },
    { text: 'Iraq', value: 'Iraq', flag: 'iq' },
    { text: 'Ireland', value: 'Ireland', flag: 'ie' },
    { text: 'Israel', value: 'Israel', flag: 'il' },
    { text: 'Italy', value: 'Italy', flag: 'it' },
    { text: 'Jamaica', value: 'Jamaica', flag: 'jm' },
    { text: 'Jan Mayen', value: 'Jan Mayen', flag: 'sj' },
    { text: 'Japan', value: 'Japan', flag: 'jp' },
    { text: 'Jordan', value: 'Jordan', flag: 'jo' },
    { text: 'Kazakhstan', value: 'Kazakhstan', flag: 'kz' },
    { text: 'Kenya', value: 'Kenya', flag: 'ke' },
    { text: 'Kiribati', value: 'Kiribati', flag: 'ki' },
    { text: 'Kuwait', value: 'Kuwait', flag: 'kw' },
    { text: 'Kyrgyzstan', value: 'Kyrgyzstan', flag: 'kg' },
    { text: 'Laos', value: 'Laos', flag: 'la' },
    { text: 'Latvia', value: 'Latvia', flag: 'lv' },
    { text: 'Lebanon', value: 'Lebanon', flag: 'lb' },
    { text: 'Lesotho', value: 'Lesotho', flag: 'ls' },
    { text: 'Liberia', value: 'Liberia', flag: 'lr' },
    { text: 'Libya', value: 'Libya', flag: 'ly' },
    { text: 'Liechtenstein', value: 'Liechtenstein', flag: 'li' },
    { text: 'Lithuania', value: 'Lithuania', flag: 'lt' },
    { text: 'Luxembourg', value: 'Luxembourg', flag: 'lu' },
    { text: 'Macau', value: 'Macau', flag: 'mo' },
    { text: 'Macedonia', value: 'Macedonia', flag: 'mk' },
    { text: 'Madagascar', value: 'Madagascar', flag: 'mg' },
    { text: 'Malawi', value: 'Malawi', flag: 'mw' },
    { text: 'Malaysia', value: 'Malaysia', flag: 'my' },
    { text: 'Maldives', value: 'Maldives', flag: 'mv' },
    { text: 'Mali', value: 'Mali', flag: 'ml' },
    { text: 'Malta', value: 'Malta', flag: 'mt' },
    { text: 'Marshall Islands', value: 'Marshall Islands', flag: 'mh' },
    { text: 'Martinique', value: 'Martinique', flag: 'mq' },
    { text: 'Mauritania', value: 'Mauritania', flag: 'mr' },
    { text: 'Mauritius', value: 'Mauritius', flag: 'mu' },
    { text: 'Mayotte', value: 'Mayotte', flag: 'yt' },
    { text: 'Mexico', value: 'Mexico', flag: 'mx' },
    { text: 'Micronesia', value: 'Micronesia', flag: 'fm' },
    { text: 'Moldova', value: 'Moldova', flag: 'md' },
    { text: 'Monaco', value: 'Monaco', flag: 'mc' },
    { text: 'Mongolia', value: 'Mongolia', flag: 'mn' },
    { text: 'Montenegro', value: 'Montenegro', flag: 'me' },
    { text: 'Montserrat', value: 'Montserrat', flag: 'ms' },
    { text: 'Morocco', value: 'Morocco', flag: 'ma' },
    { text: 'Mozambique', value: 'Mozambique', flag: 'mz' },
    { text: 'Namibia', value: 'Namibia', flag: 'na' },
    { text: 'Nauru', value: 'Nauru', flag: 'nr' },
    { text: 'Nepal', value: 'Nepal', flag: 'np' },
    { text: 'Netherlands', value: 'Netherlands', flag: 'nl' },
    { text: 'Netherlandsantilles', value: 'Netherlandsantilles', flag: 'an' },
    { text: 'New Caledonia', value: 'New Caledonia', flag: 'nc' },
    { text: 'New Guinea', value: 'New Guinea', flag: 'pg' },
    { text: 'New Zealand', value: 'New Zealand', flag: 'nz' },
    { text: 'Nicaragua', value: 'Nicaragua', flag: 'ni' },
    { text: 'Niger', value: 'Niger', flag: 'ne' },
    { text: 'Nigeria', value: 'Nigeria', flag: 'ng' },
    { text: 'Niue', value: 'Niue', flag: 'nu' },
    { text: 'Norfolk Island', value: 'Norfolk Island', flag: 'nf' },
    { text: 'North Korea', value: 'North Korea', flag: 'kp' },
    { text: 'Northern Mariana Islands', value: 'Northern Mariana Islands', flag: 'mp' },
    { text: 'Norway', value: 'Norway', flag: 'no' },
    { text: 'Oman', value: 'Oman', flag: 'om' },
    { text: 'Pakistan', value: 'Pakistan', flag: 'pk' },
    { text: 'Palau', value: 'Palau', flag: 'pw' },
    { text: 'Palestine', value: 'Palestine', flag: 'ps' },
    { text: 'Panama', value: 'Panama', flag: 'pa' },
    { text: 'Paraguay', value: 'Paraguay', flag: 'py' },
    { text: 'Peru', value: 'Peru', flag: 'pe' },
    { text: 'Philippines', value: 'Philippines', flag: 'ph' },
    { text: 'Pitcairn Islands', value: 'Pitcairn Islands', flag: 'pn' },
    { text: 'Poland', value: 'Poland', flag: 'pl' },
    { text: 'Portugal', value: 'Portugal', flag: 'pt' },
    { text: 'Puerto Rico', value: 'Puerto Rico', flag: 'pr' },
    { text: 'Qatar', value: 'Qatar', flag: 'qa' },
    { text: 'Réunion', value: 'Réunion', flag: 're' },
    { text: 'Romania', value: 'Romania', flag: 'ro' },
    { text: 'Russia', value: 'Russia', flag: 'ru' },
    { text: 'Rwanda', value: 'Rwanda', flag: 'rw' },
    { text: 'Saint Barthélemy', value: 'Saint Barthélemy', flag: 'fr' },
    { text: 'Saint Helena', value: 'Saint Helena', flag: 'sh' },
    { text: 'Saint Kitts and Nevis', value: 'Saint Kitts and Nevis', flag: 'kn' },
    { text: 'Saint Lucia', value: 'Saint Lucia', flag: 'lc' },
    { text: 'Saint Martin', value: 'Saint Martin', flag: 'fr' },
    { text: 'Saint Pierre and Miquelon', value: 'Saint Pierre and Miquelon', flag: 'pm' },
    { text: 'Saint Vincent', value: 'Saint Vincent', flag: 'vc' },
    { text: 'Samoa', value: 'Samoa', flag: 'ws' },
    { text: 'San Marino', value: 'San Marino', flag: 'sm' },
    { text: 'Sandwich Islands', value: 'Sandwich Islands', flag: 'gs' },
    { text: 'Sao Tome', value: 'Sao Tome', flag: 'st' },
    { text: 'Saudi Arabia', value: 'Saudi Arabia', flag: 'sa' },
    { text: 'Scotland', value: 'Scotland', flag: 'gb' },
    { text: 'Senegal', value: 'Senegal', flag: 'sn' },
    { text: 'Serbia', value: 'Serbia', flag: 'rs' },
    { text: 'Seychelles', value: 'Seychelles', flag: 'sc' },
    { text: 'Sierra Leone', value: 'Sierra Leone', flag: 'sl' },
    { text: 'Singapore', value: 'Singapore', flag: 'sg' },
    { text: 'Slovakia', value: 'Slovakia', flag: 'sk' },
    { text: 'Slovenia', value: 'Slovenia', flag: 'si' },
    { text: 'Solomon Islands', value: 'Solomon Islands', flag: 'sb' },
    { text: 'Somalia', value: 'Somalia', flag: 'so' },
    { text: 'South Africa', value: 'South Africa', flag: 'za' },
    { text: 'South Korea', value: 'South Korea', flag: 'kr' },
    { text: 'Spain', value: 'Spain', flag: 'es' },
    { text: 'Sri Lanka', value: 'Sri Lanka', flag: 'lk' },
    { text: 'Sudan', value: 'Sudan', flag: 'sd' },
    { text: 'Suritext', value: 'Suritext', flag: 'sr' },
    { text: 'Swaziland', value: 'Swaziland', flag: 'sz' },
    { text: 'Sweden', value: 'Sweden', flag: 'se' },
    { text: 'Switzerland', value: 'Switzerland', flag: 'ch' },
    { text: 'Syria', value: 'Syria', flag: 'sy' },
    { text: 'Taiwan', value: 'Taiwan', flag: 'tw' },
    { text: 'Tajikistan', value: 'Tajikistan', flag: 'tj' },
    { text: 'Tanzania', value: 'Tanzania', flag: 'tz' },
    { text: 'Thailand', value: 'Thailand', flag: 'th' },
    { text: 'Timorleste', value: 'Timorleste', flag: 'tl' },
    { text: 'Togo', value: 'Togo', flag: 'tg' },
    { text: 'Tokelau', value: 'Tokelau', flag: 'tk' },
    { text: 'Tonga', value: 'Tonga', flag: 'to' },
    { text: 'Trinidad', value: 'Trinidad', flag: 'tt' },
    { text: 'Tunisia', value: 'Tunisia', flag: 'tn' },
    { text: 'Turkey', value: 'Turkey', flag: 'tr' },
    { text: 'Turkmenistan', value: 'Turkmenistan', flag: 'tm' },
    { text: 'Tuvalu', value: 'Tuvalu', flag: 'tv' },
    { text: 'U.A.E.', value: 'U.A.E.', flag: 'ae' },
    { text: 'Uganda', value: 'Uganda', flag: 'ug' },
    { text: 'Ukraine', value: 'Ukraine', flag: 'ua' },
    { text: 'United Kingdom', value: 'United Kingdom', flag: 'gb' },
    { text: 'United States', value: 'United States', flag: 'us' },
    { text: 'Uruguay', value: 'Uruguay', flag: 'uy' },
    { text: 'US Minor Islands', value: 'US Minor Islands', flag: 'um' },
    { text: 'US Virgin Islands', value: 'US Virgin Islands', flag: 'vi' },
    { text: 'Uzbekistan', value: 'Uzbekistan', flag: 'uz' },
    { text: 'Vanuatu', value: 'Vanuatu', flag: 'vu' },
    { text: 'Vatican City', value: 'Vatican City', flag: 'va' },
    { text: 'Venezuela', value: 'Venezuela', flag: 've' },
    { text: 'Vietnam', value: 'Vietnam', flag: 'vn' },
    { text: 'Wales', value: 'Wales', flag: 'gb' },
    { text: 'Wallis and Futuna', value: 'Wallis and Futuna', flag: 'wf' },
    { text: 'Western Sahara', value: 'Western Sahara', flag: 'eh' },
    { text: 'Yemen', value: 'Yemen', flag: 'ye' },
    { text: 'Zambia', value: 'Zambia', flag: 'zm' },
    { text: 'Zimbabwe', value: 'Zimbabwe', flag: 'zw' },
];

export default countryList;